export default {
  name: 'page-builder',

  componentDidMount () {
    const firstTarget = document.querySelector(`.${this.props.target}`)

    if (firstTarget) {
      const wrapper = document.createElement('div')
      wrapper.classList.add(this.props.target.replace('in-', ''))
      firstTarget.parentNode.insertBefore(wrapper, firstTarget)

      document.querySelectorAll(`.${this.props.target}`).forEach(item => {
        wrapper.append(item)
      })
    }
  },
}
